import { DetectedFile } from "../types";

import { ImageDisplay } from "./ImageDisplay";
import { VideoDisplay } from "./VideoDisplay";
import { AudioDisplay } from "./AudioDisplay";
import { TextDisplay } from "./TextDisplay";
import { PdfDisplay } from "./PdfDisplay";
import { LinkDisplay } from "./LinkDisplay";
import { UnknownFileDisplay } from "./UnknownFileDisplay";

interface FileDisplayContentProps {
  data: string;
  detectedFile: DetectedFile;
  isViewing: boolean;
  setIsViewing: (isViewing: boolean) => void;
  saveData?: (newData: string, previousData: string, index?: number) => void;
  showEditButton?: boolean;
  isEditing?: boolean;
  isInCollection?: boolean;
  setIsEditing: (isEditing: boolean) => void;
}

export const FileDisplayContent = ({
  data,
  detectedFile,
  isViewing,
  setIsViewing,
  saveData,
  showEditButton,
  isEditing,
  isInCollection,
  setIsEditing,
}: FileDisplayContentProps) => {
  switch (detectedFile.type) {
    case "image":
      return (
        <ImageDisplay
          data={data}
          detectedFile={detectedFile}
          isViewing={isViewing}
          setIsViewing={setIsViewing}
        />
      );
    case "video":
      return (
        <VideoDisplay
          data={data}
          detectedFile={detectedFile}
          isViewing={isViewing}
          setIsViewing={setIsViewing}
        />
      );
    case "audio":
      return (
        <AudioDisplay
          data={data}
          detectedFile={detectedFile}
          isViewing={isViewing}
          setIsViewing={setIsViewing}
        />
      );
    case "text":
    case "json":
    case "csv":
      return (
        <TextDisplay
          data={data}
          detectedFile={detectedFile}
          isViewing={isViewing}
          setIsViewing={setIsViewing}
        />
      );
    case "pdf":
      return (
        <PdfDisplay
          data={data}
          detectedFile={detectedFile}
          isViewing={isViewing}
          setIsViewing={setIsViewing}
        />
      );
    case "link":
      return (
        <LinkDisplay
          data={data}
          isViewing={isViewing}
          saveData={saveData}
          setIsViewing={setIsViewing}
          isEditing={Boolean(showEditButton && isEditing)}
          setIsEditing={setIsEditing}
          isInCollection={isInCollection}
          detectedFile={detectedFile}
        />
      );
    default:
      return <UnknownFileDisplay data={data} detectedFile={detectedFile} />;
  }
};
